module.exports = __webpack_public_path__ + "img/nine.4a2d1ca0.svg";